import { useCallback, useEffect } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { SecondaryButtonRouterLink } from 'components/Button';
import { Button } from 'components/Button/Button';
import { useABExperimentBucket } from 'containers/ABExperiment';
import { colors, gutterWidth } from 'theme/theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEventOnce } from 'utils/analytics/track/trackEventOnce';
import { getStaticImageSrc } from 'utils/getImageSrc';
import {
  NOTIFICATIONS,
  NotificationStatus,
  useUpdateLocalNotification,
} from 'utils/localNotifications';

const CloseButton = styled(Button)`
  opacity: 0.999; /* is invisible without this, why? */
`;

export function SalarySurveyBanner() {
  const updateLocalNotification = useUpdateLocalNotification();

  const handleDismiss = useCallback(
    () =>
      updateLocalNotification(NOTIFICATIONS.SALARY_SURVEY_CTA, {
        status: NotificationStatus.DISMISSED,
      }),
    [updateLocalNotification],
  );

  const bucket = useABExperimentBucket({
    experimentId: 'SALARY_SURVEY_CTA_TEXT',
    defaultBucket: 'LETS_GO',
  });

  useEffect(() => {
    trackEventOnce('Displayed: Salary Survey Ad', {
      context: 'Header Banner',
    });
  }, []);

  return (
    <Box
      data-qa-id="banner-ad"
      data-ad-type="salary-survey"
      position="relative"
      zIndex={101}
      bg={colors.brandBlue}
      color="white"
      display="flex"
      py={12}
      pl={gutterWidth / 2}
      pr={gutterWidth / 2 - 16}
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage={`url('${getStaticImageSrc(
          'salary-survey-banner.svg',
        )}')`}
        backgroundSize="cover"
        backgroundPosition="center"
      />
      <Box
        position="relative"
        minHeight={[160, 80, null, 92]}
        width={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={['wrap', 'nowrap', null, null]}
      >
        <Box
          pr={[0, 10, null, null]}
          mt={['5px', 0, null, null]}
          mb={[2, 0, null, null]}
          fontSize={[16, null, null, 18]}
        >
          {getText('Discover what other nonprofit professionals are earning.')}
        </Box>
        <SecondaryButtonRouterLink
          to="/nonprofit-salary-explorer"
          reverse
          onClick={() => {
            trackClicked('Clicked: Salary Survey Ad', {
              cta_type: 'Button',
              button_text:
                (bucket === 'EXPLORE_SALARIES' &&
                  getText('Explore Salaries')) ||
                (bucket === 'LETS_GO' && getText("Let's Go!")),
              url: '/nonprofit-salary-explorer',
              context: 'Header Banner',
            });
            handleDismiss();
          }}
        >
          <Box minHeight={24} display="flex" alignItems="center">
            <Box display="block">
              {(bucket === 'EXPLORE_SALARIES' && getText('Explore Salaries')) ||
                (bucket === 'LETS_GO' && getText("Let's Go!"))}
            </Box>
          </Box>
        </SecondaryButtonRouterLink>
      </Box>
      <CloseButton
        data-qa-id="close-banner-ad-button"
        onClick={handleDismiss}
        variant="legacy-tertiary-white"
        icon={{ type: 'normalized', name: 'close' }}
      />
    </Box>
  );
}
